// ==================================================================================
// Digital Approval System (DAS) - ProtectedRoute
// ==================================================================================
// Route guard for the authenticated app shell. If the user is not authenticated
// (no valid token), redirect to login using `replace` so this protected route is
// NOT left in the browser history — this is what stops the browser Back button
// from re-entering the dashboard after logout, and prevents Back/Forward from
// bouncing between the dashboard and the login page.
//
// Uses the same auth signal as the login page's auto-redirect
// (authService.isAuthenticated → tokenUtils.getToken) so the two never disagree.
// Mirrors the CRS ProtectedRoute pattern.
// ==================================================================================

import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from 'api/services';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, redirectTo = '/' }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
